var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleDriveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 48,
    viewBox: "0 0 56 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.23624 48L18.4712 32.0001H55.4139L46.1781 48H9.23624Z",
    fill: "#3777E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9431 32H55.4139L36.9431 0H18.4712L36.9431 32Z",
    fill: "#FFCF63"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32L9.23621 48L27.7069 16L18.4712 0L0 32Z",
    fill: "#11A861"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDriveIcon);
export default __webpack_public_path__ + "static/media/google-drive-icon.7aa6ca98a3c6cf273f6cf011c8a1bfc6.svg";
export { ForwardRef as ReactComponent };